<kendo-dialog
	title="Document Agreement"
	*ngIf="dialogOpened"
	(close)="close('dialog')"
	[minWidth]="250"
	[width]="350">
	<div>
		<button
			class="doc-download wrap-btn"
			kendoButton
			[title]="documentTitle"
			[svgIcon]="downloadIcon"
			(click)="downloadFileByDocId(documentId)">
			{{ documentTitle }}
		</button>
	</div>
	<div
		class="error-msg"
		*ngIf="showErrorMsg">
		Please downlaod the document by clicking the link and reviewing it before agreeing.
	</div>
	<kendo-dialog-actions>
		<button
			kendoButton
			kpaKendoButton="secondary"
			(click)="close('dialog')">
			Cancel</button
		>&nbsp;
		<button
			kendoButton
			[ngClass]="!isReadDocEnabled ? 'disabled-button' : 'primary-button'"
			(click)="completeTraining(documentId)">
			I Agree
		</button>
	</kendo-dialog-actions>
</kendo-dialog>
